import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=3ca328b9&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=3ca328b9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca328b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ca328b9')) {
      api.createRecord('3ca328b9', component.options)
    } else {
      api.reload('3ca328b9', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=3ca328b9&scoped=true", function () {
      api.rerender('3ca328b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contents/setting/components/Pagination.vue"
export default component.exports